import GenericForm from 'components/GenericForm';
import type { GenericFormFields, SitecoreBlockProps } from 'models/sitecore';

interface Props extends SitecoreBlockProps {
	fields?: GenericFormFields;
}

export default function AccountJulaProSignupForm({ fields }: Props) {
	if (!fields) {
		return null;
	}
	return (
		<GenericForm
			formLocation="AccountJulaProSignupForm"
			sections={fields.sections}
			errorView={fields.error}
			successView={fields.success}
			loadingView={fields.loading}
		/>
	);
}
AccountJulaProSignupForm.displayName = 'AccountJulaProSignupForm_Partial';
